import { TextField } from "@mui/material"
import moment from "moment"
import { ChangeEventHandler } from "react"





export interface InputProps {
  labelText: string
  inputType?: string
  placeHolder?: string
  id?: string
  onChange: (input: string) => void
  showError?: boolean
  errorMessage?: string
  maxLength?: number
  pattern?: string
  inputmode?: string
  disabled?:boolean
}


export const AppInput = (props: InputProps) => {

  const {
    labelText,
    placeHolder,
    inputType,
    onChange,
    errorMessage,
    showError,
    maxLength,
    pattern,
    inputmode,
    disabled
  } = props

  return (
    <>
      <div className="form-group">
        <label className="fw-500" >{labelText}</label>
        <input pattern={pattern && pattern} maxLength={maxLength && maxLength}
          type={inputType ? inputType : "text"}
          disabled={disabled}
          className={showError ? "form-control is-invalid" : "form-control"}
          aria-describedby="emailHelp" placeholder={placeHolder} onChange={(event) => {
            onChange(event.target.value)
          }} />
        {<div className="invalid-feedback">
          {errorMessage}
        </div>
        }
      </div>
    </>
  )
}



export interface CustomInputProps {
  labelText: string
  inputType?: string
  id?: string
  onChange: (input: any) => void
  showError?: boolean
  errorMessage?: string
  value?: any
  showHeader?: boolean
  inputProps?:any
  onInput?:any
  disabled?:boolean
}


export const CustomInput = (props: CustomInputProps) => {

  const {
    labelText,
    id,
    inputType,
    onChange,
    errorMessage,
    showError,
    value,
    showHeader,
    inputProps,
    onInput,
    disabled
  } = props



  return (
    <>
      <div className="form-group">
       
        {showHeader && <label className="fw-500" >{labelText}</label>}

        <TextField
          id={id}
          label={labelText}
          inputProps={inputProps}
          onChange={onChange}
          disabled={disabled}
          onInput={onInput}
          type={inputType}
          className={showError ? "form-control is-invalid" : "form-control"}
          InputLabelProps={{ shrink: true, required: true }}
        />
        {<div className="invalid-feedback">
          {errorMessage}
        </div>
        }
      </div>
    </>
  )
}